module.exports = __webpack_public_path__ + "img/26aa3eae04afc870e0c309e8dfaf69d3.png";